<template>
  <BottomSheet :show="show" @close="$emit('close')">
    <div class="flex justify-center -mt-12 mb-2">
      <div class="bg-primary rounded-full w-20 h-20 flex items-center justify-center shadow-lg border-4 border-white">
        <i class="bx bx-badge-check text-white text-4xl"></i>
      </div>
    </div>
    <div class="px-6 text-center">
      <h2 class="text-2xl font-bold mb-2 mt-2">Accedi per proseguire</h2>
      <p class="text-gray-500 mb-6">Sarà sufficiente indicare il numero.</p>
      <CuButton primary class="w-full mb-4" @click="$emit('phone')">
        <i class="bx bx-phone text-2xl"></i>
        Candidati con il tuo numero
      </CuButton>
      <div class="flex items-center my-4">
        <div class="flex-1 h-px bg-gray-200"></div>
        <span class="mx-3 text-gray-400 font-medium">oppure</span>
        <div class="flex-1 h-px bg-gray-200"></div>
      </div>
      <CuButton secondary class="w-full" @click="$emit('email')">
        <i class="bx bx-envelope text-2xl"></i>
        Accedi con l'email
      </CuButton>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'

export default {
  name: "CandidateLoginTypeModal",
  components: { BottomSheet, CuButton },
  props: {
    show: { type: Boolean, default: false }
  }
}
</script>
